import Button from './ui/Button';
import useCalendly from '../hooks/useCalendly';

export default function HomeHero() {
  const { open } = useCalendly();

  return (
    <section
      id="hero"
      className="relative isolate overflow-hidden bg-cover text-white min-h-[72vh] md:min-h-[88vh] lg:min-h-[92vh] hero-background"
      style={{
        backgroundImage: "url('/images/Home-Sailboat.jpg')"
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/8" aria-hidden="true" />
      <div className="relative mx-auto flex max-w-5xl flex-col items-center px-4 pb-24 pt-40 text-center md:items-start md:px-6 md:pb-40 md:pt-56 md:text-left">
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl md:text-6xl">
          NAVIGATE WEALTH <span className="whitespace-nowrap">WITH CONFIDENCE</span>
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/90 sm:text-lg md:max-w-3xl md:mt-4">
          Navigating your portfolio’s seas to meet your goals is tough.<br />
          Let us make it easy for you.
        </p>
        <div className="mt-8 flex w-full flex-col items-center gap-4 sm:w-auto md:items-start">
          <Button
            type="button"
            variant="primary"
            className="w-full sm:w-auto shadow-[0_10px_30px_rgba(43,82,136,0.35)] focus:ring-offset-transparent"
            onClick={() => open()}
          >
            Schedule a Review
          </Button>
        </div>
      </div>
    </section>
  );
}
